import type {Identificador} from '../types'

type TipoPerfil = 'fornecedor' | 'transportadora'

export const agendaExternaKeys = {
  all: ['agenda-externa'] as const,
  filiais: () => [...agendaExternaKeys.all, 'filiais'] as const,
  volumes: (filial: Identificador) => [...agendaExternaKeys.all, 'volumes', filial] as const,
  volumeGeral: (filial: Identificador) => [...agendaExternaKeys.all, 'volume-geral', filial] as const,
  parceiros: (isFornecedor: boolean, codigoUsuario: Identificador) =>
    [...agendaExternaKeys.all, 'parceiros', isFornecedor ? 'transportadoras' : 'fornecedores', codigoUsuario] as const,
  nfe: (origem: 'agenda' | 'tributum', chaveAcesso: string) =>
    [...agendaExternaKeys.all, 'nfe', origem, chaveAcesso] as const,
}

export const followUpKeys = {
  all: ['follow-up'] as const,
  ordensCompra: () => [...followUpKeys.all, 'ordens-compra'] as const,
  itens: (idOrdemCompra: Identificador) => [...followUpKeys.all, 'itens', idOrdemCompra] as const,
  filial: (idOrdemCompra: Identificador) => [...followUpKeys.all, 'filial', idOrdemCompra] as const,
}

export const agendaRecebimentoKeys = {
  all: ['agenda-recebimento'] as const,
  agendamentos: (tipoPerfil: TipoPerfil, codigoUsuario: Identificador, filial: Identificador, status: string) =>
    [...agendaRecebimentoKeys.all, 'agendamentos', tipoPerfil, codigoUsuario, filial, status] as const,
  detalhes: (agendaId: Identificador) => [...agendaRecebimentoKeys.all, 'detalhes', agendaId] as const,
  resumo: (agendaId: Identificador) => [...agendaRecebimentoKeys.all, 'resumo', agendaId] as const,
  notas: (numeroNotaFiscal: Identificador, codigoUsuario: Identificador) =>
    [...agendaRecebimentoKeys.all, 'notas', numeroNotaFiscal, codigoUsuario] as const,
  conhecimentos: (agendaId: Identificador) => [...agendaRecebimentoKeys.all, 'conhecimentos', agendaId] as const,
}
